import * as React from 'react';
import { WorkflowTag } from '@pinpointhq/thumbtack';
import { Stage } from '../../../../../javascript/models';

export interface IWorkflowTagCellProps {
  stage: Stage;
}

export function WorkflowTagCell({ stage }: IWorkflowTagCellProps) {
  return <WorkflowTag variant={stage?.basicType} text={stage?.name} />;
}
